import React from 'react'
import styled from '@emotion/styled'
import { Auth } from 'aws-amplify'
import { colors } from 'Utils'
import { Modal } from 'antd'
import logoClave from 'Assets/logo/logo-clave.svg'

let modalReactivation = null

export const showReactivationModal = (user, unfreezeDealer) => {

  if (!user.distActivo && user.profile && user.profile.id === 'GE') {
    modalReactivation = Modal.confirm({
      title: (
        <ConfirmTitle>
          <img alt="Logotipo Clave X" src={logoClave} />
        </ConfirmTitle>
      ),
      content: (
        <div style={{ textAlign: 'center' }}>
          <p>Bienvenido de nuevo</p>
          <p>Por razones de seguridad, su cuenta está congelada.</p>
          <p>Para poder disfrutar de CLAVE, proceda a la reactivación.</p>
        </div>
      ),
      confirmLoading: true,
      width: 500,
      icon: null,
      centered: true,
      okText: 'Reactivar',
      cancelText: 'Salir',
      okButtonProps: {
        onClick: () => {
          modalReactivation.update({
            okButtonProps: {
              loading: true,
              disabled: true,
            },
            cancelButtonProps: {
              disabled: true,
            },
            okText: 'Reactivando...',
          })
          unfreezeDealer({
            variables: {
              codDistribuidor: user.codDistribuidor
            }
          })
            .then((response) => {
              modalReactivation.destroy();
              Modal.confirm({
                title: (
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                  }}>
                    <div style={{
                      flex: 1,
                      textAlign: 'center',
                      fontWeight: 'bold',
                      marginLeft: '20%' // agrega un margen a la izquierda
                    }}>
                      AVISOS IMPORTANTES
                    </div>
                    <ConfirmTitle>
                      <img alt="Logotipo Clave X" src={logoClave} />
                    </ConfirmTitle>
                  </div>
                )
                ,
                content: (
                  <React.Fragment>
                    <p>Recuerde que, para poder disfrutar de CLAVE, deberá asegurar lo siguiente:</p>
                    <ul>
                      <li>El envío de información desde su ERP debe estar activado y planificado (de lo contrario, no visualizará la información en CLAVE).</li>
                      <li>Si necesita la información de inmediato, deberá realizar un envío manual desde su ERP.</li>
                      <li>LA información se mostrará tras su próximo envío planificado (o 2 horas después de su envío manual).</li>
                      <li>Si tiene dudas acerca de los envíos planificados en su ERP, podrá consultar próxima fecha y hora en su sistema.</li>
                      <li>Visualice la actualización de sus datos en la sección "Ver actividad" de CLAVE.</li>
                    </ul>
                  </React.Fragment>
                ),
                width: 800,
                icon: null,
                centered: true,
                okText: 'Aceptar',
                okButtonProps: {
                  style: {
                    transform: 'translateX(-325%)'
                  }
                },
                cancelButtonProps: { style: { display: 'none' } },
              });
            })
          return false;
        }
      },
      onCancel: () => {
        Auth.signOut();
      },
    });
  }
  else if (!user.distActivo && user.profile && user.profile.id !== 'GE') {
    modalReactivation = Modal.confirm({
      title: '',
      content: (
        <div style={{ textAlign: 'center' }}>
          <p>Bienvenido de nuevo</p>
          <p>Por razones de seguridad, su cuenta está congelada.</p>
          <p>Contacte con el gerente para poder acceder a la información.</p>
        </div>
      ),
      icon: null,
      width: 500,
      centered: true,
      okText: 'Salir',
      okButtonProps: {
        style: {
          transform: 'translateX(-165%)'
        }
      },
      cancelButtonProps: { style: { display: 'none' } },
      onOk: () => {
        Auth.signOut();
      }
    })
  }
}
  ;


// const ConfirmTitle = styled.div`
//   font-size: 18px;
//   color: ${colors.black};
// `
const ConfirmTitle = styled.div`
  color: ${colors.black};
  display: flex;
  justify-content: flex-end;
  height: 75px;
`

const Text = styled.p`
  font-size: 16px;
  height: 150px;
`